import { map, pick } from 'lodash'

const transformToUpdateFoodMoodRelationsDetailsArgs = data => ({
  ...pick(data, ['dishTypes']),
  dishTypes: map(data.dishTypes, item => item?.value ?? item),
})

export default transformToUpdateFoodMoodRelationsDetailsArgs
